import { render, staticRenderFns } from "./CardResizeDashboard.vue?vue&type=template&id=2aeb5206&lang=pug&"
import script from "./CardResizeDashboard.vue?vue&type=script&lang=js&"
export * from "./CardResizeDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CardResizeDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports